import {useEffect, useState} from "react";
import axios from "axios";
import {PATHS_API} from "../../enum";

// Лише щоб показати посилання на адмінку; справжню перевірку робить сервер (AdminGuard)
let cached: Promise<boolean> | null = null;

export const useIsAdmin = (loggedIn: boolean) => {
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (!loggedIn) { setIsAdmin(false); return; }
        cached ??= axios.get(PATHS_API.ADMIN_ME, { withCredentials: true }).then(() => true, () => false);
        cached.then(setIsAdmin);
    }, [loggedIn]);

    return isAdmin;
};
